import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import MuiTypography from '@mui/material/Typography';
import MuiBox from '@mui/material/Box';
import Hint from '../Hint/Hint.js';

const Root = styled(MuiBox, {
    shouldForwardProp: prop => !['bgColor', 'bgHoverColor'].includes(prop),
})(({ theme, disabled, bgColor, bgHoverColor }) => {
    if (disabled) {
        // no matter what the bgColor is we will set it to N40 if the pill is disabled
        bgColor = theme.palette['N40'].main;
    }
    const style = {
        transition: 'background-color 0.3s linear, color 0.3s linear',
        minWidth: '12px',
        maxWidth: 'max-content',
        height: '13px',
        lineHeight: '1.5',
        borderRadius: '3px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: disabled ? 'not-allowed' : 'pointer',
        padding: theme.spacing(0, 0.75),
        backgroundColor: bgColor !== null && bgColor !== void 0 ? bgColor : theme.palette['N30'].main,
        color: theme.palette.N70.main,
    };
    if (!disabled) {
        style['&:hover'] = {
            backgroundColor: bgHoverColor !== null && bgHoverColor !== void 0 ? bgHoverColor : theme.palette.N20.main,
        };
    }
    return style;
});
/**
 * Small Pill component
 */
const PillSmall = (_a) => {
    var { children, 'data-testid': testId = 'small-pill', hintDuration, hint } = _a, rest = __rest(_a, ["children", 'data-testid', "hintDuration", "hint"]);
    return (jsx(Hint, Object.assign({ title: hint, placement: "bottom-end", duration: hintDuration }, { children: jsx(Root, Object.assign({ "data-testid": testId }, rest, { children: jsx(MuiTypography, Object.assign({ variant: "subtitle4" }, { children: children })) })) })));
};

export { PillSmall as default };
//# sourceMappingURL=PillSmall.js.map
